import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  currentRouteKey: "",
  projectId: "",
  centralBankList: [],
  regionalBankList: [],
  insuranceCompanyList: [],
  selectedProject: {},
};

export const commonSlice = createSlice({
  name: "base/common",
  initialState,
  reducers: {
    setCurrentRouteKey: (state, action) => {
      state.currentRouteKey = action.payload;
    },
    setProjectId: (state, action) => {
      state.projectId = action.payload;
    },
    setCentralBankList: (state, action) => {
      state.centralBankList = action.payload;
    },
    setRegionalBankList: (state, action) => {
      state.regionalBankList = action.payload;
    },
    setInsuranceCompanyList: (state, action) => {
      state.insuranceCompanyList = action.payload;
    },
    setSelectedProject: (state, action) => {
      state.selectedProject = action.payload;
    },
  },
});

export const {
  setCurrentRouteKey,
  setProjectId,
  setSelectedProject,
  setCentralBankList,
  setRegionalBankList,
  setInsuranceCompanyList,
} = commonSlice.actions;

export default commonSlice.reducer;
